/**
 * Labstep
 *
 * @module components/Layout/Menu/TopBar/Profile
 * @desc Profile (opening in right side bar)
 */

import { LayoutMenuTopBarProfileMobile } from 'labstep-web/components/Layout/Menu/TopBar/Profile/Mobile';
import { UserActionSignoutContainer as UserActionSignout } from 'labstep-web/components/User/Action/Signout';
import { UserShowPersonalNotes as PersonalNotes } from 'labstep-web/components/User/Show/PersonalNotes';
import Profile from 'labstep-web/components/User/Show/Profile';
import { UserShowSettings as Settings } from 'labstep-web/components/User/Show/Settings';
import { ICONS } from 'labstep-web/constants/icons';
import { withAuthenticatedUserEntity } from 'labstep-web/containers/AuthenticatedUser';
import { Dropdown } from 'labstep-web/core/Dropdown';
import { Icon } from 'labstep-web/core/Icon';
import type React from 'react';
import type { LayoutMenuTopBarProfileProps } from './types';
import LayoutMenuTopBarProfileViewComponent from './ViewComponent';

export const LayoutMenuTopBarProfile: React.FC<
  LayoutMenuTopBarProfileProps
> = ({ authenticatedUserEntity }) => {
  if (!authenticatedUserEntity) {
    return null;
  }

  return (
    <Dropdown
      pointing="top right"
      icon={null}
      trigger={<LayoutMenuTopBarProfileViewComponent />}
    >
      <LayoutMenuTopBarProfileMobile />
      <PersonalNotes
        user={authenticatedUserEntity}
        viewComponent={({ toggleModal }): React.ReactElement => (
          <Dropdown.Item onClick={toggleModal}>
            <Icon name={ICONS.thread.primary} />
            Personal Notes
          </Dropdown.Item>
        )}
      />
      <Profile
        user={authenticatedUserEntity}
        viewComponent={({ toggleModal }): React.ReactElement => (
          <Dropdown.Item onClick={toggleModal}>
            <Icon name="user circle" />
            Profile
          </Dropdown.Item>
        )}
      />
      <Settings
        user={authenticatedUserEntity}
        viewComponent={({ toggleModal }): React.ReactElement => (
          <Dropdown.Item onClick={toggleModal}>
            <Icon name="cog" />
            Account Settings
          </Dropdown.Item>
        )}
      />
      <UserActionSignout
        actionComponentProps={{
          icon: 'sign out',
          type: 'option',
        }}
      />
    </Dropdown>
  );
};

export default withAuthenticatedUserEntity(LayoutMenuTopBarProfile);
